import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {ApiGridSearch} from '@assets/js/api/commonApi.js';

const CompGridMatchTrmnt = forwardRef((props, ref) => {
    // Forward ref to allow parent components to call event functions.
    // This is useful for controlling the modal from outside this component.
    useImperativeHandle(ref, () => ({
        onGridSearch: (p_params) => {
            onGridSearch(p_params);
        },
    }));

    /**********************
     * Define Grid vaiable
     ***********************/
    // State for grid pagination and loading
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });

    // Define columns for DataGrid
    const columns = [
        { field: 'rowNum', headerName: 'No.', width: 65, headerAlign: 'center', align: 'center' },
        { field: 'comptnNm', headerName: '대회명', width: 250, headerAlign: 'center', align: 'left' },
        { field: 'mtmkgStatNm', headerName: '대진상태', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'dvsnNm', headerName: '부문', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'wetclsNm', headerName: '체급', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'armTypeNm', headerName: '팔 유형', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'seedNo', headerName: '시드번호', width: 100, headerAlign: 'center', align: 'center',
            renderCell: (params) => (
                <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleRowClick(params)}>
                    {params.value}
                </span>
            )
        },
        { field: 'seedTypeNm', headerName: '시드', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'plyrNmA', headerName: '선수A', width: 150, headerAlign: 'center', align: 'left' },
        { field: 'plyrNmB', headerName: '선수B', width: 150, headerAlign: 'center', align: 'left' },
        { field: 'winPlyrNm', headerName: '승자', width: 150, headerAlign: 'center', align: 'left' },
        { field: 'losePlyrNm', headerName: '패자', width: 150, headerAlign: 'center', align: 'left' },
    ];

    /*********************
     * Define Grid events
     ***********************/
    const onGridSearch = (p_params) => {
        let params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            offset: paginationModel.page*paginationModel.pageSize,
            ...p_params
        }

        // <-- loading start
        setLoading(true);
        // Fetch data from the server
        ApiGridSearch('/sys/matchtrmntmng/search/list', params)
        .then(res => {
            if (res.data.result) {
                const rows = res.data.dataList.length > 0 ? res.data.dataList : [];
                const totalCount = res.data.dataList.length > 0 ? res.data.dataList[0].totalCount : 0;
                setRows(rows);
                setTotalRowCount(totalCount);
            }
            setRowSelectionModel({ type: 'include', ids: new Set() });
        })
        .catch(error => {
            console.error('Error fetching match tournament list:', error);
        })
        .finally(() => {
            // <-- loading end
            setLoading(false);
        });
    }

    // Pass selected row data to parent component
    const handleRowClick = (params) => {
        if (params.field === 'seedNo') {
            // if (params.row.mtmkgStat === 'E') {
            //     alert("수정할 수 없는 상태입니다.(대진 종료)");
            // } else {
            // }
            props.onChildClick(params.row);
        }
    };

    /**********************
     * Define useEffect
     ***********************/
    useEffect(() => {
        onGridSearch();
        // eslint-disable-next-line
    }, [paginationModel]);

    return (
        <>
            <div className="grid-container">
                <h4>대진 토너먼트 목록</h4>
            </div>
            <div className="grid-wrapper">
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => `${row.mngCd}|${row.mtmkgCd}|${row.armType}|${row.seedNo}`}
                    loading={loading}
                    pageSizeOptions={[100, 200, 500]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    paginationMode="server"
                    rowCount={totalRowCount}
                    checkboxSelection
                    rowSelectionModel={rowSelectionModel}
                    onRowSelectionModelChange={(newSelection) => {
                        if (props.onSelectionChange) {
                            setRowSelectionModel(newSelection);
                            props.onSelectionChange(newSelection);
                        }
                    }}
                    keepNonExistentRowsSelected
                />
            </div>
        </>
    );
});

export default CompGridMatchTrmnt;
